/**
 * `fetch` rejects with a TypeError when the server cannot be reached: Chrome
 * « Failed to fetch », Firefox « NetworkError… », Safari « Load failed »,
 * React Native « Network request failed ». Other TypeErrors are bugs.
 *
 * Kept free of imports: `services/http` would close a cycle through the auth store.
 */
export function isFetchNetworkError(error: unknown): boolean {
  return error instanceof TypeError && /fetch|network|load failed/i.test(error.message);
}

function numberProp(error: unknown, key: string): number | undefined {
  if (typeof error !== 'object' || error === null || !(key in error)) return undefined;
  const value = (error as Record<string, unknown>)[key];
  return typeof value === 'number' ? value : undefined;
}

/** HTTP status carried by an `HttpError`, read without importing it. */
export function errorStatus(error: unknown): number | undefined {
  return numberProp(error, 'status');
}

/**
 * Lower-cases the first letter of a sentence put after « : » (French
 * typography), unless it starts an acronym (« HTTP », « API ») or the
 * language capitalises nouns (German).
 */
export function asReason(message: string, language = 'fr'): string {
  if (language.startsWith('de')) return message;
  if (message.length < 2 || message[1] === message[1].toLowerCase()) {
    return message.charAt(0).toLowerCase() + message.slice(1);
  }
  return message;
}
